import { useState } from "react";
import { ChevronDown, ExternalLink } from "lucide-react";

// Embeds PBO's public live leaderboard page (spec §4). No auth, auto-refreshes itself.
export const PboLiveBoard = ({ url, tournamentName, defaultOpen = true }) => {
  const [open, setOpen] = useState(defaultOpen);
  if (!url) return null;
  return (
    <section
      className="bg-white border border-pbo-border rounded-2xl shadow-sm overflow-hidden"
      data-testid="pbo-live-board"
    >
      <div className="flex items-center justify-between gap-3 px-5 py-3 border-b border-pbo-border">
        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex items-center gap-2 text-left"
          data-testid="pbo-live-board-toggle"
        >
          <ChevronDown
            className={`w-4 h-4 text-pbo-muted transition-transform ${open ? "" : "-rotate-90"}`}
          />
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-pbo-muted font-semibold flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />
              Tournament leaderboard · live from PBO
            </div>
            <div className="font-serif text-pbo-green text-lg leading-tight">
              {tournamentName || "On the course"}
            </div>
          </div>
        </button>
        <a
          href={url}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-1 text-xs font-semibold text-pbo-green hover:text-pbo-gold whitespace-nowrap"
          data-testid="pbo-live-board-open-link"
        >
          Full screen <ExternalLink className="w-3.5 h-3.5" />
        </a>
      </div>
      {open && (
        <iframe
          title="PBO live leaderboard"
          src={url}
          loading="lazy"
          className="w-full h-[560px] bg-pbo-paper"
          data-testid="pbo-live-board-iframe"
        />
      )}
    </section>
  );
};
